import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {ElasticSearchTreff, IndeksertEntitet, InternlenkeMålEntitetType, LenkerelasjonId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {entitetTypeFraTreff} from "felles-ng2/modell/indekssøkeresultatModellHjelpere";
import {EntitetId} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";

/** Leser data-uuid attributt fra angitt element */
export function lesUuidFraInternlenke(element: HTMLElement): string | null {
    return element.getAttribute('data-uuid') ?? null;
}

/** Returnerer uuid fra angitt attributter som 'data-uuid' attributt for bruk på internlenke HTML-a-tag */
export function internlenkeUuidSomDataTypeAttributt(attributer: LenkeAttributter): Record<string, string> {
    return erIkkeNil(attributer.dataUuid) ? {'data-uuid': attributer.dataUuid} : {};
}

/** Leser data-type attributt fra angitt element, returnerer {@link InternlenkeMålEntitetType} */
export function lesTypeFraInternlenke(element: HTMLElement): InternlenkeMålEntitetType | null {
    let typeSomTekst = element.getAttribute('data-type');
    //ckeditor bruker ikke InterlenkeEntitetType, men egne streng-konstanter
    switch (typeSomTekst) {
      //dersom lenke opprettet i ckeditor
        case 'sak':
            return InternlenkeMålEntitetType.sak;
        case 'dokument':
            return InternlenkeMålEntitetType.opplastetDokumentVersjon;
      //dersom lenke opprettet i tiptap
        default:
            return typeSomTekst as InternlenkeMålEntitetType;
    }
}

/** Returnerer type fra angitt attributter som 'data-type' attributt for bruk på internlenke HTML-a-tag */
export function internlenkeTypeSomDataTypeAttributt(attributer: LenkeAttributter): Record<string, string> {
    return erIkkeNil(attributer.dataType) ? {'data-type': attributer.dataType} : {};
}

/** Leser data-id attributt fra angitt element */
export function lesIdFraInternlenke(element: HTMLElement): ReferertEntitetId | null {
    return element.getAttribute('data-id') ?? null;
}

/** Returnerer id fra angitt attributter som 'data-id' attributt for bruk på internlenke HTML-a-tag */
export function internlenkeIdSomDataTypeAttributt(attributer: LenkeAttributter): Record<string, string> {
    return erIkkeNil(attributer.dataId) ? {'data-id': attributer.dataId} : {};
}

/** Sann dersom angitt lenkeattributter har dataUuid (med mindre støttCkeditorLenker=true), dataId og dataType satt */
export function erInternLenke(lenkeattributter: LenkeAttributter, støttCkeditorLenker = false): lenkeattributter is InternlenkeAttributter {
    return (erIkkeNil(lenkeattributter.dataUuid) || støttCkeditorLenker) && erIkkeNil(lenkeattributter.dataId) && erIkkeNil(lenkeattributter.dataType);
}

/** Returnerer {@link InternlenkeMålEntitetType} knyttet til angitt søketreff  */
export function internlenkeTypeFraSøketreff(treff: ElasticSearchTreff<any>): InternlenkeMålEntitetType {
    //vi vet at InternlenkeMålEntitetType er et subset av EntitetType, ref no.systemfabrikken.lederplan.domene.lenkerelasjon.Internlenke.InternlenkeMålEntitetType
    // @ts-ignore
    return entitetTypeFraTreff(treff) as InternlenkeMålEntitetType;
}

/** Returnerer {@link IndeksertEntitet} knyttet til angitt {@link InternlenkeMålEntitetType}. */
export function indeksertEntitetFraInternlenkeMålEntitetType(type: InternlenkeMålEntitetType): IndeksertEntitet {
    //IndeksertEntitet har entitetens klassenavn som verdi, som er det samme som InternlenkeMålEntitetType benytter, ref no.systemfabrikken.lederplan.domene.lenkerelasjon.Internlenke.InternlenkeMålEntitetType
    // @ts-ignore
    return type as IndeksertEntitet;
}


// typedefinisjoner

/** Iden til entiteten som internlenken peker til */
export type ReferertEntitetId = EntitetId;

/** Lenkeattributter definert av Tiptap Link utvidelsen */
export interface TiptapLenkeattributter {
    href?: string;
    target?: string;
    rel?: string;
    class?: string;
}

/** Attributter definert av vår {@link Lenke} Tiptap utvidelse.
 * Eksponert via {@link Node#attrs} */
export interface InternlenkeAttributter extends TiptapLenkeattributter {
    /** {@link LenkerelasjonId} til {@link LenkerelasjonModell} innslaget som representerer denne internlenken.
     * Påkrevet kun for internlenker */
    dataUuid: LenkerelasjonId;
    /** {@link EntitetId} til entiteten lenken referer til. Påkrevet kun for internlenker */
    dataId: ReferertEntitetId;
    /** {@link EntitetType} til entiteten lenken referer til. Påkrevet kun for internlenker */
    dataType: InternlenkeMålEntitetType;
}

export interface EksternlenkeAttributter extends TiptapLenkeattributter {
}

export type LenkeAttributter = EksternlenkeAttributter & Partial<InternlenkeAttributter>;
